module.exports = "/fonts/illustrasi-line-dash-lamp-63a74460bab3b2d4e9eb321273d935be.svg";